/**
 * @generated SignedSource<<c05c2ec52120765ca5a485f842f6f4e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TicketAiSummaryState = "READY" | "NO_ACTIVITY" | "FAILED" | "PENDING" | "CREDIT_EXHAUSTED" | "%future added value";
export type TicketStatus = "open" | "in_progress" | "waiting_on_customer" | "resolved" | "closed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AiSummaryBlock_ticket$data = {
  readonly id: string;
  readonly status: TicketStatus;
  readonly aiSummaryState: TicketAiSummaryState;
  readonly aiSummaryRefusalMessage: string | null;
  readonly aiSummary: {
    readonly summary: string;
    readonly statusSignal: string;
    readonly sentiment: string;
    readonly commentCount: number;
    readonly emailCount: number;
    readonly generatedAt: string;
    readonly modelVersion: string;
    readonly feedbackScore: number | null;
    readonly feedbackText: string | null;
    readonly isFinal: boolean;
    readonly staleness: {
      readonly isStale: boolean;
      readonly newComments: number;
      readonly newEmails: number;
      readonly newStatusEvents: number;
      readonly total: number;
    } | null;
  } | null;
  readonly aiSuggestedActions: ReadonlyArray<{
    readonly id: string;
    readonly title: string;
    readonly suggestedDueDate: string | null;
    readonly rationale: string | null;
    readonly confidence: number | null;
    readonly status: string;
    readonly assignee: {
      readonly id: string;
      readonly fullName: string | null;
      readonly initials: string | null;
      readonly profilePictureId: string | null;
      readonly active: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"ticketingPerson_person">;
    } | null;
  }>;
  readonly " $fragmentType": "AiSummaryBlock_ticket";
};
export type AiSummaryBlock_ticket$key = {
  readonly " $data"?: AiSummaryBlock_ticket$data;
  readonly " $fragmentSpreads": FragmentRefs<"AiSummaryBlock_ticket">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AiSummaryBlock_ticket",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aiSummaryState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aiSummaryRefusalMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketAiSummary",
      "kind": "LinkedField",
      "name": "aiSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusSignal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sentiment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commentCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modelVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "feedbackScore",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "feedbackText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFinal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TicketAiSummaryStaleness",
          "kind": "LinkedField",
          "name": "staleness",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isStale",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newComments",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newEmails",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newStatusEvents",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketAiSuggestedAction",
      "kind": "LinkedField",
      "name": "aiSuggestedActions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "suggestedDueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rationale",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "confidence",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "assignee",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "initials",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePictureId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ticketingPerson_person"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Ticket",
  "abstractKey": null
};
})();

(node as any).hash = "7b0ccccf33a46cb22be95a6664f04d6e";

export default node;
